module.exports = __webpack_public_path__ + "static/media/KSlogo.3af7b53e.png";